function nextProjectNameGenerator(name, items) {
    if (items.indexOf(name) === -1) {
        return name;
    }

    let indexes = ['1'];

    for (let i = 0; i < items.length; i++) {
        if (items[i].includes(name)) {
            let match = items[i].match(/\(\d+\)/gm);
            if (match) {
                indexes.push(+match[0].replace('(', '').replace(')', ''));
            }
        }
    }

    return `${name} (${Math.max.apply(null, indexes) + 1})`;
}

export default nextProjectNameGenerator;
